var _circle, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDustCoverWoodwick = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 88 80",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 40,
    r: 25,
    fill: "none",
    stroke: "#1d1d1b",
    strokeMiterlimit: 10,
    strokeWidth: 2.2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 6.09,
    x: 34,
    y: 36.95,
    fill: "none",
    stroke: "#1d1d1b",
    strokeMiterlimit: 10,
    strokeWidth: 2.2,
    rx: 3.05,
    ry: 3.05
  })));
};
export default SvgDustCoverWoodwick;